'use client';

import PropTypes from "prop-types";
import { useState, useContext, createContext, useMemo } from 'react';

// ----------------------------------------------------------------------

const SearchContext = createContext({});

export const useSearchContext = () => {
  const context = useContext(SearchContext);

  if (!context) {
    throw new Error('useSearchContext must be used inside SearchProvider');
  }

  return context;
};

export function SearchProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState('');

  const value = useMemo(() => ({
    isOpen,
    setIsOpen,
    query,
    setQuery,
  }), [isOpen, query]);

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
}

SearchProvider.propTypes = {
  children: PropTypes.node,
}
